export function addToCart(id, name, category, quantity, price) {
    if(typeof window.gtag === 'undefined') {
        console.log('gtag does not exist...')
    } else {
        window.gtag('event', 'add_to_cart', {
            'items': [
                {
                    id,
                    name,
                    category,
                    quantity,
                    price
                }
            ]
        })
    }
}

export const initiateCheckout = (cart) => {
    if(typeof window.gtag === 'undefined') {
        console.log('gtag does not exist...')
    } else {
        window.gtag('event', 'begin_checkout', {
            coupon: cart.couponCode,
            currency: cart.currency,
            items: cart.lineItems.map(lineItem => ({
                id: lineItem.sku,
                name: lineItem.description,
                price: lineItem.total,
                quantity: lineItem.qty
            })),
            value: cart.total
        });
    }
}

export const search = (query) => {
    if(typeof window.gtag === 'undefined') {
        console.log('gtag does not exist...')
    } else {
        window.fbq('track', 'Search');
    }
}

export const purchase = (order) => {
        if(typeof window.gtag === 'undefined') {
            console.log('debug::gtag does not exist...')
        } else {
            gtag('event', 'purchase', {
                transaction_id: order.reference,
                coupon: order.couponCode ,
                value: order.total,
                shipping: order.totalShippingCost,
                tax: order.totalTax,
                currency: order.currency,
                items: order.lineItems.map(lineItem => ({
                    id: lineItem.sku,
                    name: lineItem.description,
                    price: lineItem.total,
                    quantity: lineItem.qty
                }
            )),
        });
    }
}
